export default {
  title: 'Components/DDA Cards/DDA Image Cards/Pricing Card/pricing card',
  tags: ['autodocs'],
  argTypes: {
    image_src: { control: 'text' },
    image_chip_icon: { control: 'text' },
    image_chip_icon_family: { control: 'text' },
    image_chip_label: { control: 'text' },
    image_chip_icon_size: {
      control: { type: 'select' },
      options: ['sm', 'md', 'lg'],
    },
    header_text: { control: 'text' },
    header_text_icon: { control: 'text' },
    body_text_icon: { control: 'text' },
    body_text: { control: 'text' },
    price_text: { control: 'text' },
    price_period: { control: 'text' },
    chip_list: { control: 'object' },
    custom_class: { control: 'text' },
    component_mode: {
      control: { type: 'check' },
      options: ['light-mode'],
    },
  },
  parameters: {
    docs: {
      description: {
        component: `
Use the \`dda-pricing-card\` component with the following props:

\`\`\`html
<dda-pricing-card
  image_src="..."
  image_chip_icon="..."
  header_text="..."
  price_text="$..."
  chip_list="[...chips]"
></dda-pricing-card>
\`\`\`

\`chip_list\` is passed as a JavaScript property (not an HTML attribute).
        `,
      },
    },
  },
};

const Template = (args) => {
  const attributes = Object.entries(args)
    .filter(([key, value]) => key !== 'chip_list' && value !== undefined && typeof value !== 'object')
    .map(([key, value]) => `${key}="${value}"`)
    .join(' ');

  const chipListJSON = JSON.stringify(args.chip_list || []);

  return `
    <dda-pricing-card ${attributes} data-chip-list='${chipListJSON}'></dda-pricing-card>
  `;
};

export const Default = Template.bind({});
Default.args = {
  image_src: 'https://lipsum.app/id/12/1800x1200',
  image_chip_label: 'Label',
  image_chip_icon: 'fiber_manual_record',
  image_chip_icon_family: 'material-icons',
  image_chip_icon_size: 'sm',

  header_text: 'Backend Team',
  header_text_icon: 'more_horiz',
  card_header_icon_id: 'cartHeaderAction',
  body_text_icon: 'sentiment_satisfied',
  body_text:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  price_text: '$1,750.00',
  price_period: 'month',

  chip_list: [
    {chip_text: '3 Bedrooms',},
    {chip_text: '1 Bathroom',},
    {chip_text: 'bnb',},
  ],

  custom_class: '',
  component_mode: '',
};
